import React from 'react'
import { ModalFormId } from 'src/components/ModalForms'
import {
  TestTableDescription,
  TestTableDescriptionSection,
  TestTableDescriptionSectionHeader,
} from 'src/components/ModalForms/Evidence/evidence.styles'
import {
  CrossReferencedDataArtifact,
  OeControlTestCitationType,
} from '@trustero/trustero-api-web/lib/artifact/artifact_pb'
import { FlexAlign, FlexRow } from 'src/components/Reusable/Flex'
import { ControlCheckSourceTitle } from '../artifacts/AuditScan/AuditScanArtifact.components'
import { AuditScanArtifactJoinInfo } from '../artifacts/AuditScan/AuditScanArtifact.constants'
import { TabularArtifactModal } from './TabularArtifactModal'

export const CrossReferencedArtifactModal = ({
  crossReferencedData,
}: {
  crossReferencedData: CrossReferencedDataArtifact
}): JSX.Element => {
  const _tableCsv = crossReferencedData?.getTable() || ''

  if (!crossReferencedData) {
    return <></>
  }

  const description: JSX.Element = (
    <TestTableDescription>
      <TestTableDescriptionSection>
        <FlexRow justify={FlexAlign.FLEX_START} isFullWidth>
          {crossReferencedData?.getJoinDescription() || ''}
          {crossReferencedData?.getJoinCriteria() || ''}
        </FlexRow>
        <TestTableDescriptionSectionHeader>
          Sources
        </TestTableDescriptionSectionHeader>
        <ControlCheckSourceTitle
          sourceId={crossReferencedData?.getEvidenceInstanceId1()}
          sourceType={OeControlTestCitationType.EVIDENCE}
          joinInfo={AuditScanArtifactJoinInfo.LEFT}
        />
        <ControlCheckSourceTitle
          sourceId={crossReferencedData?.getEvidenceInstanceId2()}
          sourceType={OeControlTestCitationType.EVIDENCE}
          joinInfo={AuditScanArtifactJoinInfo.RIGHT}
        />
      </TestTableDescriptionSection>
    </TestTableDescription>
  )

  return (
    <TabularArtifactModal
      formId={ModalFormId.CROSS_REFERENCED_ARTIFACT_MODAL}
      title={`Cross-referenced data`}
      description={description}
      csv={''}
    />
  )
}
